<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="pageTitle"
      [canGoBack]="true"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'finance-skeleton right-side-scroll-enabled' : 'finance-skeleton'">
      @if (!loaded) {
        <div style="width: 100%; margin-bottom: 16px;">
          <ion-skeleton-text [animated]="true" style="height: 96px; border-radius: 12px" />
        </div>
        @for (i of [1,2,3,4,5]; track i) {
          <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 14px;">
            <ion-skeleton-text [animated]="true" style="width: 22px; height: 22px; border-radius: 50%" />
            <ion-skeleton-text [animated]="true" style="width: 55%; height: 16px; border-radius: 4px" />
          </div>
        }
      }

      @if (loaded && connections.length === 0) {
        <tidy-error-message [text]="errorMessage" />
      }

      @if (loaded && connections.length > 0) {
        <tidy-alert class="black-background">
          @if (isNewConnection) {
            <tidy-row>
              <tidy-text
                [header]="connections.length === 1 ? 'Your bank is connected' : 'Your banks are connected'" />
            </tidy-row>
          }
          @for (label of connectionLabels; track label) {
            <tidy-row>
              <tidy-text
                [body]="label"
                [translate]="false" />
            </tidy-row>
          }
          <tidy-row class="extra-top-padding">
            @if (isNewConnection) {
              <tidy-text [body]="'Transactions count from today. Want to also import past transactions into your P&L?'" />
            } @else {
              <tidy-text [body]="'Only bank transactions from this date onward feed your P&L. Moving the date earlier imports older transactions. Moving it later hides older bank rows but keeps any P&L transactions already created from them.'" />
            }
          </tidy-row>
        </tidy-alert>

        <tidy-row class="extra-top-padding field-bottom-padding">
          <tidy-radio-button
            [label]="'Count transactions from'"
            formControlName="choice"
            [form]="form.controls.choice"
            [items]="rangeItems"
            [submitted]="submitted"
            [errorMessage]="'Please choose an option'" />
        </tidy-row>
        @if (showCustomDate) {
          <tidy-row class="field-bottom-padding">
            <tidy-datepicker
              [label]="'Start date'"
              formControlName="customDate"
              [form]="form.controls.customDate"
              [submitted]="submitted"
              [errorMessage]="'Please choose a date'" />
          </tidy-row>
        }

        @if (errorMessage) {
          <tidy-error-message [text]="errorMessage" />
        }

        <div class="finance-button-row">
          @if (isNewConnection) {
            <div class="finance-button-row__button">
              <tidy-button
                [text]="'Not Now'"
                [action]="boundSkip"
                class="secondary" />
            </div>
          }
          <div class="finance-button-row__button">
            <tidy-button
              [text]="isNewConnection ? 'Import Transactions' : 'Save'"
              [action]="boundSave"
              [disabled]="saving"
              class="primary" />
          </div>
        </div>
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
